import PropTypes from 'prop-types'
import TabGroup from './TabGroup'
import TabButtons from './TabButtons'
import Tab from './Tab'
import TabList from './TabList'
import TabLinks from './TabLinks'
import SydMiniTabList from './MiniTabList'
import SydIconTabList from './IconTabList'

export const useCurrentTab = () => {
  const tabs = useCurrentTab()
  return tabs.selectedValue
}

const SydTabs = ({ children }) => {
  return children
}

SydTabs.propTypes = {
  children: PropTypes.node
}

SydTabs.Group = TabGroup
SydTabs.Buttons = TabButtons
SydTabs.List = TabList
SydTabs.Tab = Tab
SydTabs.Links = TabLinks
SydTabs.MiniList = SydMiniTabList
SydTabs.IconList = SydIconTabList

export default SydTabs
